import { GenericAbortSignal } from 'axios';

import { DischargeChecklist, DischargeChecklistItem } from 'models/DischargeChecklistItem';
import http from 'services/http';

export const dischargeChecklistQueryKeys = {
  base: ['dischargeChecklists'],
  index: (clientId?: string) => ['dischargeChecklists', 'index', { clientId }],
};

// Undefined clientId is the acting client's own lists (Configuration). A clientId is an Olio admin
// looking at that client's lists from Admin > Clients.
function basePath(clientId?: string) {
  return clientId ? `/admin/clients/${clientId}` : '';
}

export async function indexDischargeChecklists(clientId: string | undefined, signal?: GenericAbortSignal) {
  return http
    .get<{ data: DischargeChecklist[] }>(`${basePath(clientId)}/discharge_checklists`, { signal })
    .then((response) => response.data.data);
}

export async function createDischargeChecklistItem({
  clientId,
  ...params
}: {
  clientId?: string;
  groupTypeId: string;
  label: string;
}) {
  return http
    .post<DischargeChecklistItem>(`${basePath(clientId)}/discharge_checklist_items`, params)
    .then((response) => response.data);
}

export async function updateDischargeChecklistItem({
  id,
  clientId,
  label,
}: {
  id: string;
  clientId?: string;
  label: string;
}) {
  return http
    .patch<DischargeChecklistItem>(`${basePath(clientId)}/discharge_checklist_items/${id}`, { label })
    .then((response) => response.data);
}

export async function destroyDischargeChecklistItem({ id, clientId }: { id: string; clientId?: string }) {
  return http.delete(`${basePath(clientId)}/discharge_checklist_items/${id}`);
}

// Every item in the list with its new 0-based position. The server stores what it's handed.
export async function reorderDischargeChecklistItems({
  clientId,
  groupTypeId,
  items,
}: {
  clientId?: string;
  groupTypeId: string;
  items: { id: string; position: number }[];
}) {
  return http
    .patch<{
      data: DischargeChecklistItem[];
    }>(`${basePath(clientId)}/discharge_checklist_items`, { groupTypeId, items })
    .then((response) => response.data.data);
}
